import { SERVICE_TYPES } from '@bagonboard/wiseman';

const {
  CHECKIN,
  CITY_DELIVERY,
  SKIP_BAGGAGE_CLAIM,
  TRANSFER,
} = SERVICE_TYPES;

export default function getServiceTypeLabels(type) {
  switch (type) {
    case CHECKIN:
      return {
        name       : 'Pick-up and Checkin',
        description: 'Pick-up and check-in',
      };
    case CITY_DELIVERY:
      return {
        name       : 'City Delivery',
        description: 'City delivery: from airport to city',
      };
    case SKIP_BAGGAGE_CLAIM:
      return {
        name       : 'Skip Baggage Claim',
        description: 'Skip Baggage Claim',
      };
    case TRANSFER:
      return {
        name       : 'Airport Delivery',
        description: 'Airport delivery',
      };
    default:
      return null;
  }
}
